import client from "lib/apolloClient/client";
import { organizationGradeItem } from "GradesSetup/modules/Fragment";

export const getOrganizationGradesFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Organization:${id}`,
      variables: { filters },
      fragment: organizationGradeItem,
      fragmentName: "organizationItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};
